/* eslint-disable import/no-named-as-default-member */
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import messages_en from './locales/en'
import filesUpload from 'src/sites/file/droparea/translations/en/filesUpload.json'

i18n.use(LanguageDetector).init({
  interpolation: { escapeValue: false },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  resources: {
    en: {
      filesUpload: filesUpload,
      ...messages_en
    }
  }
})

export default i18n